import { render, staticRenderFns } from "./SchoolAwayEntitlementTable.vue?vue&type=template&id=e3b8d270&scoped=true&"
import script from "./SchoolAwayEntitlementTable.vue?vue&type=script&lang=js&"
export * from "./SchoolAwayEntitlementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b8d270",
  null
  
)

export default component.exports